import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { AuthProvider } from "./context/AuthContext";
import { SyncProvider } from "./context/SyncContext";
import ReloadPrompt from "./components/ReloadPrompt";
import { Toaster } from "sonner";
import { OfflineIndicator } from "./components/common/OfflineIndicator";
import { ErrorBoundary } from "./components/common/ErrorBoundary";

function App() {
  return (
    <ErrorBoundary>
      <I18nextProvider i18n={i18n}>
        <AuthProvider>
          <SyncProvider>
            <BrowserRouter basename={import.meta.env.BASE_URL}>
              <AppRoutes />
              <ReloadPrompt />
              <OfflineIndicator />
              <Toaster position="top-center" richColors />
            </BrowserRouter>
          </SyncProvider>
        </AuthProvider>
      </I18nextProvider>
    </ErrorBoundary>
  );
}

export default App;
